import { useState, useEffect, useRef } from "react";

import styles from "./finish.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import AppBar from "../../components/appBar/appBar";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getUserInfo } from "../../api/api";
import { useUserData } from '../../functions/updateUserData';
import { renderWithLineBreaksAndBold } from '../../functions/renderWithLineBreaksAndBold';


const Finish = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData,setUserData } = useUserData();

  // t("explanation.info_types", { returnObjects: true })
  const [coupon, setCoupon] = useState("");
  const loading = useRef("");

  // const politics_cards = t("end.politics_cards", { returnObjects: true })
  // const assorted_cards = t("end.assorted_cards", { returnObjects: true })
  const cards = t("end.cards", { returnObjects: true })
  const couponsRef = useRef(t("end.codes", { returnObjects: true }));

  useEffect(() => {
    if (loading.current) return;
    const init = async () => {
      loading.current = true;
      // const coupons = t("end.codes", { returnObjects: true })
      try {
        const responseUser = await getUserInfo(userData.tokens["access_token"]);
        console.log(responseUser)
        if (responseUser.user_register_complete && responseUser.media_survey_complete && userData.finishedSurveyGame){
          // here set the const [coupon, setCoupon] = useState("");
          // to one of the coupons from the list above.
          const randomCoupon = couponsRef.current[Math.floor(Math.random() * couponsRef.current.length)];
          setCoupon(randomCoupon);
        }
      } catch (error) {
        console.error("Session init failed:", error);
      } finally{
        loading.current = false;
      }
    }
    
    init();
  }, [userData]);

  // redirect in 30 seconds
  useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        navigate("/"); // redirect to homepage
      }, 30000); // 30 seconds
    };

    // Start initial timer
    resetTimer();

    // On scroll -> reset timer
    const handleScroll = () => {
      resetTimer();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [navigate]);

  const get2random = (arr) => {
    const index1 = Math.floor(Math.random() * arr.length);
    let index2 = Math.floor(Math.random() * arr.length);
    while (index1 === index2) {
      index2 = Math.floor(Math.random() * arr.length);
    }
    return [arr[index1], arr[index2]];
  };

  const getCads = (arrImages, arrCards) => {
    const imgs = get2random(arrImages);
    const card = get2random(arrCards);
    return [
      [imgs[0], card[0]],
      [imgs[1], card[1]],
    ];
  };

  const arrImages =[ImgBuilder.teenProfileGullibleSharer,
    ImgBuilder.teenProfileCuriousBeliever,
    ImgBuilder.teenProfileCautiousExplorer,
    ImgBuilder.teenProfileSharpEyedAnalyst,
    ImgBuilder.teenProfileMixedScanner]


  
  
  const playAgain = () => {
    setUserData(prev => ({
      ...prev,
      statistics: null
    }));
    navigate('/topics')
  };      
  
  

  return (
    <div className={styles.wrapper}>
      <AppBar />
      
      
      <div className={styles.container}>
        <p className={styles.headerTop}>{t("end.top_text")}</p>
        <p className={styles.headerMain}>{renderWithLineBreaksAndBold(t("end.top_description"))}</p>

        <div className={styles.cardsConainer}>

          {getCads(arrImages,cards).map(([image, card], idx) => (
            <div key={idx} className={styles.card}>
              <img alt="icon" className={styles.imgIconCard} src={image} />
              <div className={styles.textCard}>{card}</div>
            </div>
          ))}
              

        </div>

        
        {coupon &&
        <>
        <p className={styles.headerMain}>{t("end.coupon_thanks")}</p>


        <div className={styles.coupon}>
          <div className={styles.leftCoupon}></div>
          <div className={styles.mainCoupon}>{coupon}</div>
        </div>
        </>
        }

        <p className={styles.headerMain}>{t("end.bot_text")}{" "}<b>{userData.tokens.user_code}</b></p>

      </div>

      <div className={styles.buttonsContainer}>
        <button onClick={() => navigate('/')}  className={styles.button}>{t("end.go_home")}</button>
        <button onClick={() => playAgain()}  className={styles.button}>{t("end.another_game")}</button>
        <button onClick={() => navigate("/contacts")} className={styles.button}>{t("end.go_contacts")}</button>
      </div>

      <img alt="bg" className={styles.bgImg} src={ImgBuilder.sbBackground}/>
    </div>
  );
};

export default Finish;
